import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { EmiStatus, FixedTenure, TenureDetails } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {
  @Input() tenureData: TenureDetails[] = [];
  @Output() selectTerm: EventEmitter<TenureDetails | Boolean> = new EventEmitter();
  coachingCenterId: any;
  courseId: any;
  loanDetails: any;
  isEditCoapplicant: boolean = false;
  showCoapplicant: boolean = false;
  formator = new Intl.NumberFormat('en-US',);
  orderId: any;
  applicantLength: any;

  constructor(private util: UtilService) {

  }
  ngOnInit(): void {

    this.tenureData = [...this.tenureData]

    this.loanDetails = { ...this.util.loanDetails };
    const loanDetails = this.loanDetails;
    this.applicantLength = loanDetails.loanApplicantDetails.length;




    this.coachingCenterId = loanDetails.institutionInfo!.coachingCenterId!;
    this.courseId = loanDetails.institutionInfo!.coachingCenterCourseId!;
    this.applicantLength = loanDetails.loanApplicantDetails.length;
    this.getFixedTenors(123456);

    if (loanDetails.loanCommercialDetails != null &&
      loanDetails.loanCommercialDetails.length) {
      var a = loanDetails.loanCommercialDetails[0].amount! <
        loanDetails.institutionInfo!.amount!;
      //  ||
      var b = loanDetails.loanCommercialDetails[0].tenor! >
        loanDetails.institutionInfo!.tenorMonths!;
      //  ||
      var c = loanDetails.loanCommercialDetails[loanDetails.loanApplicantDetails.length - 1].amount! <
        loanDetails.institutionInfo!.amount!;
      //  ||
      var d = loanDetails.loanCommercialDetails[loanDetails.loanApplicantDetails.length - 1].tenor! >
        loanDetails.institutionInfo!.tenorMonths!;
      //  ||
      if (a || b || c || d) {
        if (loanDetails.loanApplicantDetails?.length == 3) {
          this.isEditCoapplicant = true;
          this.showCoapplicant = true;
        } else {
          this.isEditCoapplicant = false;
          this.showCoapplicant = true;
        }
      }
    }
  }


  getFixedTenors(selectedTenor: number) {
    this.util.handleRequests('get', this.util.getUrl('loan_fixedtenures', [this.coachingCenterId, this.courseId])).then((res: any) => {
      if (res != null) {
        const data: FixedTenure[] = res;
        const num: FixedTenure[] = [];
        const selectedTenorNum: FixedTenure[] = [];
        data.forEach((d: FixedTenure) => {
          if (selectedTenor != 123456 && d.tenor >= selectedTenor) {
            selectedTenorNum.push(d);
          }
          if (selectedTenor == 123456) {
            num.push(d);
          }
        });
        const x = (selectedTenor != 123456 ? selectedTenorNum : num).sort((a, b) => a.tenor - b.tenor);
        this.loanDetails = { ...this.loanDetails, tenorData: x };
      } else {
        throw Error();
      }
    }).catch(() => {
      const copyData: FixedTenure[] = [];
      for (let i = selectedTenor != 123456
        ? selectedTenor
        : this.loanDetails.institutionInfo?.minTenor;
        i <= this.loanDetails.institutionInfo?.maxTenor; i++) {
        copyData.push(
          {
            institutionId: this.coachingCenterId,
            courseId: this.courseId,
            tenor: i,
            refInstitutionId: this.coachingCenterId,
            interestRate: 0, subvention: 0, emiType: 'standard', customerRoi: 0,
          }
        );
      }
      const tenorData = selectedTenor != 123456 ? [
        {
          institutionId: this.coachingCenterId,
          tenor: selectedTenor, refInstitutionId: this.coachingCenterId,
          interestRate: 0, subvention: 0, emiType: 'standard', customerRoi: 0,
        },
        {
          institutionId: this.coachingCenterId,
          tenor: this.loanDetails.institutionInfo.maxTenor, refInstitutionId: this.coachingCenterId,
          interestRate: 0, subvention: 0, emiType: 'standard', customerRoi: 0,
        },
      ] : [
        {
          institutionId: this.coachingCenterId,
          tenor: this.loanDetails.institutionInfo.minTenor, refInstitutionId: this.coachingCenterId,
          interestRate: 0, subvention: 0, emiType: 'standard', customerRoi: 0,
        },
        {
          institutionId: this.coachingCenterId,
          tenor: this.loanDetails.institutionInfo.maxTenor, refInstitutionId: this.coachingCenterId,
          interestRate: 0, subvention: 0, emiType: 'standard', customerRoi: 0,
        },
      ];


      this.loanDetails = { ...this.loanDetails, tenorDataCopy: copyData, tenorData: tenorData };
    })
  }


  get termText(): string {
    if (this.loanDetails.loanCommercialDetails[0].emiBeforeMoratorium !=
      null) {
      return 'Includes moratorium & fixed EMI';
    } else {
      return 'This is the maximum loan tenure';

    }
  }


  submitTerms(term: TenureDetails) {
    this.util.cleverTapEventCall(CleverTapConstents.accepted_loan_terms,{
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
    this.selectTerm.emit(term);
  }



  addCoapplicants() {

    if (this.loanDetails.pullbackAllowed) {
      this.orderId = (this.loanDetails.loanApplicantDetails[this.applicantLength - 1].orderId || 0) + 1;
      if (this.applicantLength > 1) {
        const coApplicant = this.loanDetails.loanApplicantDetails.find((app: any) => !app.mainApplicant);
        // replace co-applicant detail
        this.util.handleRequests('put', this.util.getUrl('loan_removeCoapplicant', [this.loanDetails.loanId, coApplicant.id]),).then((res: any) => {
          if (res['status'] == 'SUCCESS') {
            this.addCoApplicant(coApplicant.orderId || 1);
          }
        });

      } else {
        this.addCoApplicant(this.orderId)
      }
    }

  }

  addCoApplicant(orderId: any) {
    this.util.handleRequests('put', this.util.getUrl('loan_addCoapplicant', [this.loanDetails.loanId, orderId])).then((res: any) => {
      this.util.cleverTapEventCall(CleverTapConstents.add_co_applicant,{
        'loanId':this.util.loanDetails.loanId,
        'productCode':this.util.loanDetails.productCategory
      });
      this.selectTerm.emit(false);
      this.util.getProducts().then(() => {
        this.util.navigationHandler();
      })

    })
  }
}
